/**
*  Copyright (c) 2020 Micro Focus Software Inc.  All Rights Reserved.
*
* THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
* AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
* WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
* TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
* AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
* INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
* PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
* CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
* OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
* ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
* THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
*/


import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SurveyService } from '../services/survey.service';
import { SurveyDetailResponse, SurveyQuestionInfo, SurveyResponseValue, SurveyResponse,
  RelatedRequestInfo } from '../model/surveydetailinfo';
import { DomSanitizer } from '@angular/platform-browser';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { CommonConstants } from '../../../../common/constants/common-constants';
import { AlertMessage } from '../../../../shared/alert/alertmessage';
import { AlertService } from '../../../../shared/alert/alert.service';

@Component({
  selector: 'zsd-surveydetail',
  templateUrl: '../view/surveydetail.component.html',
  styleUrls: ['../view/surveydetail.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SurveyDetailComponent implements OnInit {

  surveyDetailResponse: SurveyDetailResponse;
  surveyQuestionInfo: SurveyQuestionInfo[];
  relatedRequestResponse: RelatedRequestInfo;
  surveyResponseRequest: SurveyResponseValue = new SurveyResponseValue();
  id: number;
  myForm: FormGroup;
  showErrorMessage = false;
  defaultScaleValue = 1;
  redirectToSurveyId: number;
  branchIndex: number;
  createSurvey: SurveyResponse = new SurveyResponse();
  endSurvey = false;
  surveryQsId: number;
  branchQuesNo: number;
  selectSurvey: boolean;
  emptySurvey: boolean;
  scaleValue = {};
  relatedRequest = false;
  requestId: number;

  constructor(private _Activatedroute: ActivatedRoute, private surveyService: SurveyService,
    public _DomSanitizer: DomSanitizer, private fb: FormBuilder, private router: Router,
    private alertService: AlertService) {

  }
  ngOnInit() {
    this.id = this._Activatedroute.snapshot.params['id'];
    this._Activatedroute
    .queryParams
    .subscribe(params => {
        this.requestId = params['requestId'];
    });
    this.myForm = this.fb.group({
      anonymousReply: ['']
    });
    this.surveyService.surveyList.subscribe(val => {
      if (val) { this.emptySurvey = true; } else { this.emptySurvey = false; }
    });
    if (this.id) {
      this.selectSurvey = false;
      this.getSurveyDetail();
    } else { this.selectSurvey = true; }
    if (this.requestId) {
      this.relatedRequest = true;
    }
  }
  getSurveyDetail() {
    this.surveyService.getSurveyDetail(this.id, this.requestId).subscribe(
      (surveyDetailResponse: SurveyDetailResponse) => {
        this.surveyDetailResponse = surveyDetailResponse;
        this.surveyQuestionInfo = surveyDetailResponse.surveryQuestionInfo;
        if (this.requestId) {
          this.relatedRequestResponse = surveyDetailResponse.relatedRequestInfo;
        }

        for (let i = 0; i < this.surveyQuestionInfo.length; i++) {

          this.myForm.addControl(this.surveyQuestionInfo[i].answerTypeName + this.surveyQuestionInfo[i].surveryQsId, new FormControl());

          if (this.surveyQuestionInfo[i].answerTypeName === 'RESPONSE_YES_NO_BRANCH') {
            this.branchQuesNo = i + 1;
            this.surveryQsId = this.surveyQuestionInfo[i].surveryQsId;
            let branchQuesId = this.surveyQuestionInfo[i].branchQsId;
            if (branchQuesId) {
              this.branchIndex = i + 1;
              this.redirectToSurveyId = this.surveyQuestionInfo.findIndex(survey => survey.surveryQsId === branchQuesId) + 1;
            } else {
              this.endSurvey = true;
            }
          }
          if (this.surveyQuestionInfo[i].required) {
            this.myForm
              .get(this.surveyQuestionInfo[i].answerTypeName + this.surveyQuestionInfo[i].surveryQsId).setValidators([Validators.required]);
          }
          if (this.surveyQuestionInfo[i].answerTypeName === 'RESPONSE_SCALE_1_X') {
            this.scaleValue[this.surveyQuestionInfo[i].surveryQsId] = this.defaultScaleValue;
          }
        }
        this.formControlValueChanged();
      },
      err => {
        this.router.navigate([CommonConstants.SURVEY_COMPONENT]);
        console.error(err.error);
      });
  }
  formControlValueChanged() {
    if (this.myForm.get('RESPONSE_YES_NO_BRANCH' + this.surveryQsId)) {
    this.myForm.get('RESPONSE_YES_NO_BRANCH' + this.surveryQsId).valueChanges.subscribe(
      (value: string) => {
        if (this.endSurvey && value === '1') {
          for (let i = this.branchQuesNo; i < this.surveyQuestionInfo.length; i++) {
            this.myForm.get(this.surveyQuestionInfo[i].answerTypeName + this.surveyQuestionInfo[i].surveryQsId).disable();
          }
          this.onSubmit();
        }
        if (value === '1') {
          for (let i = this.branchIndex; i < this.redirectToSurveyId - 1; i++) {
            this.myForm.get(this.surveyQuestionInfo[i].answerTypeName + this.surveyQuestionInfo[i].surveryQsId).disable();
            this.myForm.get(this.surveyQuestionInfo[i].answerTypeName + this.surveyQuestionInfo[i].surveryQsId).updateValueAndValidity();
          }
        }
        if (value === '0') {
          for (let i = this.branchIndex; i < this.redirectToSurveyId - 1; i++) {
            this.myForm.get(this.surveyQuestionInfo[i].answerTypeName + this.surveyQuestionInfo[i].surveryQsId).enable();
            this.myForm.get(this.surveyQuestionInfo[i].answerTypeName + this.surveyQuestionInfo[i].surveryQsId).updateValueAndValidity();
          }
        }
      }
    );
    }
  }
  closeAlert() {
    this.showErrorMessage = false;
  }

  onSubmit() {
    if (this.myForm.valid) {
      this.createSurvey = new SurveyResponse();
      this.showErrorMessage = false;
      this.createSurvey.surveyResponseValues = new Array<SurveyResponseValue>();
      this.createSurvey.surveyId = this.id;
      if (this.myForm.get('anonymousReply').value === true) {
        this.createSurvey.anonymousReply = 1;
      } else {
        this.createSurvey.anonymousReply = 0;
      }
      if (this.requestId) {
        this.createSurvey.requestId = this.requestId;
      }
      for (let i = 0; i < this.surveyQuestionInfo.length; i++) {
        if (this.myForm.get(this.surveyQuestionInfo[i].answerTypeName + this.surveyQuestionInfo[i].surveryQsId).value !== null) {
          this.surveyResponseRequest = new SurveyResponseValue;
          let questionId = this.surveyQuestionInfo[i].surveryQsId;
          this.surveyResponseRequest.questionId = questionId;
          if (this.surveyQuestionInfo[i].answerTypeName === 'RESPONSE_SCALE_1_X') {
            // tslint:disable-next-line: radix
            let value = parseInt(this.scaleValue[this.surveyQuestionInfo[i].surveryQsId]);
            let responseScaleValue = (value - 6).toString();
            this.surveyResponseRequest.answer = responseScaleValue;
          } else {
            this.surveyResponseRequest.answer = this.myForm
              .get(this.surveyQuestionInfo[i].answerTypeName + this.surveyQuestionInfo[i].surveryQsId).value;
          }
          this.createSurvey.surveyResponseValues.push(this.surveyResponseRequest);
        }
      }

      this.surveyService.createSurvey(this.id, this.createSurvey).subscribe(
        (response) => {
          console.log(response);
          const alertMessage = new AlertMessage();
          alertMessage.type = 'info';
          alertMessage.message = 'Alert.surveySubmitted';
          this.alertService.displayAlert(alertMessage);
          this.router.navigate([CommonConstants.SURVEY_COMPONENT]);
        },
        err => {
          console.error(err.error);
        }
      );
    } else {
      this.showErrorMessage = true;
    }
  }
}
